// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clamp[data-v-3f8aaed6]{line-height:1.2;min-height:1.2em;overflow:hidden;padding-right:1px}.clamp div[data-v-3f8aaed6]{display:inline}.collabst[data-v-3f8aaed6]{height:1.2em}.read-link[data-v-3f8aaed6]{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
